import { LanguageResourse } from '../en';

const LANGUAGE_FILE_UK: LanguageResourse = {
	header: {
		toolbar: {
			report: 'Звіти',
			certificates: 'Сертифікати',
			education: 'Навчання',
			news: 'Новини',
			gradebook: 'Щоденник',
			market: 'Маркет',
			appointment: 'Відпрацювання',
			student: 'студент',
			emptyVideo: 'Tutorial has not been added yet',
			billing: 'Рахунки',
		},
	},
	certificates: {
		main: 'Сертифікати',
		details: 'Деталі',
		download: 'Завантажити',
		requirements: 'Вимоги до сертифіката',
		finalTestGrade: 'Бал за виконання фінального тесту мінімум 70%',
		homeworkPercent: 'Кількість виконаних домашніх завдань мінімум 75%',
		scoreGrade: 'середній бал за роботу на уроці мінімум 70%',
		overallGrade: 'середній бал за домашні завдання мінімум 70%',
		downloadText: 'Завантажити сертифікат:',
		emptyDataTitle: 'Місце для твоїх досягнень🏆',
		averageNull: 'Тут зʼявиться ваш сертифікат, щойно програму буде пройдено! Успіхів💪',
	},
	pwa: {
		push: 'Pwa push',
		installBanner: {
			campus: 'До Campus',
			install: 'Встановити PWA',
			tutorial: 'Watch video tutorial',
		},
	},
	scorm: {
		rotateHint:
			'Для виконання завдання поверніть телефон горизонтально або відкрийте урок з комп’ютера — так зручніше 😉',
	},
	market: {
		main: 'Маркет',
	},
	report: {
		yearsOfStudy: 'Роки навчання',
		gradeNumber: '{{count}}-й клас',
		aboutMe: {
			strengths: 'Сильні сторони',
			personalityQualities: 'Особисті якості',
			interests: 'Інтереси',
		},
		goals: {
			main: 'Цілі',
			specifycResults: 'Конкретні результати',
			continuation: 'Продовжити',
			breakeDown: 'Розберіть поетапно, як ви будете досягати мети',
			addSteps: 'Додати крок до цілі',
			describeSubGoal: 'Кроки до досягнення цілі',
		},
		individuality: {
			main: 'Індивідуальність',
			hobbies: 'Хобі',
			values: 'Цінності',
			talents: 'Таланти',
		},
		achievements: {
			main: 'Досягнення',
			academicAchievements: 'Академічні досягнення',
			mentorSupport: 'Менторський супровід',
			documents: {
				title: 'Документи',
				subTitle: 'PDF файл',
				files: {
					gyms: 'Інформація про спортзали - Спортзали',
					onlineLearning: 'Алгоритм переведення на тимчасове онлайн навчання',
					poolRules: 'Правила відвідування басейну',
					handbook: 'TIS: довідник для учнів та батьків',
					faq: 'FAQ TIS',
				},
			},
			myEducationPlannerPortfolio: 'Мої навчальні цілі',
			emptyData: 'Нові дані будуть додаватися протягом року.',
			projects: 'Проєкти',
			knowledge: 'Знання',
			files: {
				one: '{{count}} файл',
				few: '{{count}} файли',
				many: '{{count}} файлів',
			},
			tooltip: 'Деяка інформація, що пояснює основну мету цього блоку',
			addFileModal: {
				title: 'Завантаження файлу',
				placeholderName: "Введіть ім'я файлу",
				placeholderType: 'Досягнення з якого поля',
				selectFile: 'Обрати файл',
				drop: 'Відпустіть, щоб завантажити',
				selectOrDrop: 'Оберіть файл або перетягніть сюди',
			},
		},
	},
	programs: {
		main: 'Програми',
		seeAll: 'Побачити всі',
		empty: 'У вас ще немає жодної програми',
		name: "Ім'я",
		lessons: {
			one: '{{count}} урок',
			few: '{{count}} уроки',
			many: '{{count}} уроків',
			deadlineExpired: 'Термін сплив',
		},
		currentLearningFlow: {
			currentDirection: 'Поточний напрям',
			directionTitle: '{{direction}} · Навчальний шлях для {{grade}} класу',
			creditsActive: '{{active}} з {{total}} кредитів активні',
			instalmentPlan: 'Поточний план розстрочки',
			nextCharge: 'Наступний платіж: <b>{{date}} · {{amount}}</b>',
		},
	},
	program: {
		teacher: 'Вчитель',
		yourProgress: 'Твій прогрес',
		inProgress: 'В процесі',
		overview: 'Огляд програми',
		checking: 'На перевірці',
		completed: 'Оцінені',
		rejected: 'Відхилено',
		visited: 'Відвідані',
		planned: 'Заплановані уроки',
		missed: 'Пропущені',
		noStatus: 'Статус не обрано',
		reviewed: 'Перевірені',
		courseProgress: 'Прогрес курсу',
		workOnThePlatform: 'Робота на платформі (Середня оцінка)',
		missedClasses: 'Пропущені заняття',
		missedLessons: 'Пропущені уроки',
		workingOff: 'Уроки для відпрацювання',
		learnt: 'Відпрацьовано',
		courseTextBooks: 'Підручники курсу',
		totalLessons: 'Всього уроків',
		lessonOpenIn: 'Урок відкриється {{date}}',
		checkingEmptyLessonsTitle: 'Схоже, тут поки нічого перевіряти',
		checkingEmptyLessonsDescription: 'Виконайте домашнє завдання і воно вже тут, як тут 😉',
		completedEmptyLessonsTitle: 'Немає завершених уроків',
		completedEmptyLessonsDescription:
			'Переконайтеся, що ви завершили свої уроки та відправили їх на перевірку. Якщо вже це зробили, просто очікуйте на оцінку від викладача! 😊',
		review: 'Переглянути',
		nonGradedAssignment: 'Завдання без оцінки',
		activeEmptyLessonsTitle: 'Немає активних уроків.',
		activeEmptyLessonsDescription:
			'Схоже, ви вже завершили всі домашні завдання, так тримати! Або ж ще не настав час для виконання наступних уроків ⌛️',
		resetEmptyLessonsTitle: 'Нічого немає.',
		resetEmptyLessonsDescription: 'Схоже, що всі уроки вдаються з першої спроби, так тримати!💥',
		certificateToolTip: 'Виконайте всі завдання, щоб завантажити файл',
		certificateDownload: 'Завантажити сертифікат',
		professionalPathDownload: 'Професійна траєкторія',
		moreLessons: 'Більше уроків',
	},
	lesson: {
		discoverYourself: 'Огляд уроку',
		nextLesson: 'Наступний урок',
		emptyTeacherComment: 'У цьому розділі відображатимуться коментарі викладача',
		emptyDetails: 'У цьому блоці відображатимуться матеріали уроку',
		files: 'Файли',
		books: 'Книги',
		links: 'Корисні посилання',
		zoomLink: 'Посилання на zoom',
		zoomId: 'Ідентифікатор доступу',
		zoomAccessCode: 'Код доступу',
		miroLink: 'Посилання на Miro',
		complete: 'Урок успішно здано',
		errorComplete: 'При здачі уроку сталася помилка',
		emptyTitle: 'Урок буде доступний через',
		teacherFeedback: 'Коментар від викладача',
		discussionBoard: 'Посилання на дискусійну дошку',
		testRules: {
			test: 'Тест',
			attention: 'Увага!',
			videoSurveillance: 'Ведеться відеоспостереження',
			description:
				'Цей тест проходить під відеоспостереженням для забезпечення чесності та прозорості.',
			title: 'Правила тесту:',
			monitoring: 'Відеоспостереження є обов’язковим',
			monitoringDescription: 'протягом усього тесту.',
			prohibited: 'Заборонено:',
			prohibitedDescription:
				'використовувати сторонні матеріали, спілкуватися з іншими або перемикатися між вкладками.',
			timeLimited: 'Час проходження тесту обмежений',
			timeLimitedDescription: '— не переривайте його без поважної причини.',
			mustAgree: 'Щоб продовжити, необхідно погодитися з правилами.',
			disagreeDescription: 'Якщо ви не погодитеся, то не зможете пройти тест',
			doNotAgree: 'Не погоджуюся',
			agree: 'Погодитися з правилами',
		},
		rubric: {
			showMore: 'Показати більше',
			tableTitle: 'Рубрика оцінювання',
			criteria: 'Критерії',
			mark: 'Оцінка',
		},
	},
	resources: {
		main: 'Ресурси',
		new: 'НОВИЙ',
		inProcess: ' В процесі',
		completed: 'Закінчено',
		titleOrAuthor: 'Назва книги чи автор',
		emptySearchTitle: 'Немає результатів для "{{search}}"',
		emptySearchSubTitle: 'Можливо, ви ввели неправильний запит. Перевірте правопис.',
		length: {
			one: '{{count}} книга',
			few: '{{count}} книги',
			many: '{{count}} книг',
		},
		emptyBooksTitle: 'Ще не додано жодної книги',
		emptyBooksDescription: 'Слідкуйте за новими навчальними ресурсами!',
		emptyMaterialTitle: 'Матеріали наразі недоступні',
		emptyMaterialDescription: 'Очікуйте на нові ресурси незабаром!',
	},
	news: {
		main: 'Новини',
		latest: 'Останні новини',
		all: 'Усі новини',
		popularity: 'Популярні',
		wasTheArticleUseful: 'Чи була стаття корисною?',
		emptyDataTitle: 'Наразі немає новин',
		emptyDataDescription: 'Слідкуйте за оновленнями!',
	},
	consultations: {
		main: 'Консультації',
		start: 'Старт',
		freeSlot: 'Вільний слот',
		notEnoughFreeSlots: 'Недостатньо послідовних вільних слотів',
		chooseSessionDuration: 'Виберіть тривалість сесії',
		consultationLimit: 'Ліміт консультацій залежить від плану студента',
		hintMessage: 'Наступна доступна 90-хвилинна консультація буде після {{date}}',
		unpurchasedModal: {
			welcome: '👋 Раді вас бачити на Campus!',
			intro:
				'Ми раді вітати вас на платформі. Наш менеджер незабаром зв’яжеться з вами, щоб допомогти зробити перші кроки.',
			message: 'А поки можете ознайомитись із платформою !',
		},
		campus: {
			welcome: '👋 Вітаємо на платформі Campus!',
			intro:
				'Щоб розпочати профорієнтаційний тест, перш за все запишіться на вступну консультацію з нашим методологом.',
			goTo: 'Перейдіть у розділ',
			timeMeeting: 'та оберіть зручний час для зустрічі.',
			bookButton: 'Записатись на консультацію',
		},
		selfPacedModal: {
			welcome: '🚀 Час діяти!',
			intro:
				'Ваш шлях починається зараз. У розділі «Програми» вже доступні перші уроки — переходьте й починайте виконання!',
			bookButton: '🔘 До програм',
		},
		consultationModal: {
			successTitle: '👍 Ви успішно записались на першу консультацію!',
			successMessage:
				'Після цієї зустрічі наступний крок - друга консультація, яка має відбутись через 7 днів. Вона допоможе визначити ваш подальший навчальний маршрут та отримати індивідуальні рекомендації.',
			successMessageSelfPaced:
				'Посилання на зустріч вже доступне у картці самої консультації, а також надіслане вам у листі на електронну пошту.',
			reminder: '📅 Ви можете забронювати її вже зараз, щоб обрати зручний час заздалегідь.',
			reminderSelfPaced: 'Чекаємо на зустріч!',
		},
		googleCalendarMeetTitle: 'Талeнтед консультація',
	},
	appointment: {
		main: 'Відпрацювання',
		lyceum: 'Зустрічі',
		talented: 'Консультації',
		chooseAProgram: 'Вибір программи',
		chooseATeacher: 'Вибір вчителя',
		missedLesson: 'Пропущено уроків: {{count}}',
		location: 'Локація',
		group: 'Клас',
		program: 'Предмет',
		teacher: 'Вчитель',
		timeZone: 'Графік роботи відображається за київським часом',
		visualGuide: {
			sectionDescription:
				'Цей розділ - ваш надійний помічник у подоланні прогалин, який допоможе зменшити кількість пропущених занять.',
			usefulInfo: 'Корисно про відпрацювання:',
			sessionDuration: 'Тривалість 1 відпрацювання: 30 хвилин.',
			sessionFormat: 'Формат: онлайн.',
			bookingSteps: 'Для запису дотримуйтесь наступних кроків:',
			selectTeacher: 'Оберіть викладача з випадаючого списку',
			selectWeek: 'Оберіть день в календарику, коли бажаєте записатись на відпрацювання',
			bookSlot:
				'Забронюйте в календарику зручний день та час у комірках з підписом “Free”. Це означає, що цей час доступний для бронювання. Щойно запис буде здійснено, ви помітите оновлений статус та інший колір вашого бронювання',
			note: 'Врахуйте, ',
			bookingRestriction:
				'будь ласка, що 🔐 біля підпису “Free” означає, що бронювання не є можливим, оскільки до бажаного часу залишається менше, ніж 12 годин.',
			sessionLinkInfo:
				'Посилання на відпрацювання буде доступне у комірці часу, який ви забронювали: натисніть на неї повторно, щоб отримати дані для приєднання.',
		},
		lyceumVisualGuide: {
			sectionDescriptionTitle:
				'Ми завжди відкриті до комунікації і знаємо, як для вас важливо мати можливість поспілкуватись з командою Ліцею у зручний для вас час',
			sectionDescription:
				'Цей розділ  — ваш надійний інструмент для планування зустрічей з представниками Ліцею: обирайте зручний час і викладача та отримуйте підтримку саме тоді, коли вона потрібна 😊',
			usefulInfo: 'Корисно про зустрічі:',
			sessionDuration: 'Тривалість 1 зустрічі: 20 хвилин.',
			selectSubject: 'Оберіть предмет з випадаючого списку ',
			selectTeacher: 'Далі оберіть викладача з випадаючого списку',
			selectWeek: 'Оберіть день в календарику, коли бажаєте записатись на зустріч',
			sessionLinkInfo:
				'Посилання на зустріч одразу буде доступне у комірці часу, який Ви забронювали. Просто натисніть на комірку ще раз і відкриється віконце з даними для приєднання!',
			meetingSuccessMessage: 'Всім легкого запису та максимальної користі від зустрічей!)',
		},
		googleCalendarTooltip: {
			title: 'Не пропусти свою сесію',
			message: 'Додайте цю подію до свого Google Календаря, щоб вчасно отримати нагадування.',
			cta: 'Додати до Google Календар',
		},
		youWantToCancel: 'Ви впевнені, що хочете скасувати запис?',
		confirmCancelAppointment: 'Так, скасувати запис',
		rejectCancelAppointment: 'Ні, повернутись назад',
		wait: 'Зачекайте,',
	},
	talented: {
		visualGuide: {
			sectionDescription:
				'Цей розділ — ваш надійний помічник у плануванні зустрічей і консультацій з профорієнтаційним фахівцем, який допоможе обрати зручні дату та час.',
			usefulInfo: 'Корисне про консультації:',
			sessionDuration: 'Тривалість консультації: від 30 хвилин до 1 години 30 хвилин',
			sessionFormat: 'Формат: онлайн через Zoom',
			bookingSteps: 'Щоб забронювати консультацію, виконайте наступні кроки:',
			selectTeacher:
				'Оберіть будь-який доступний час, позначений як «Вільно». Скористайтеся календарем, щоб переглянути інші дати.',
			selectWeek:
				'Переконайтеся, що обрані час і тривалість консультації правильні. Введіть номер телефону та натисніть «Забронювати».',
			bookSlot:
				'Ваш заброньований час буде підсвічений зеленим у календарі. Натисніть на нього, щоб переглянути деталі та отримати посилання на зустріч. Наставник приєднається у вибрані дату й час.',
			note: 'Зверніть увагу, ',
			bookingRestriction:
				'будь ласка, що 🔐 біля «Вільно» означає, що бронювання неможливе, оскільки залишилось менше ніж 12 годин до бажаного часу.',
			sessionLinkInfo:
				'Посилання на консультацію буде доступне в обраному слоті: натисніть ще раз, щоб отримати деталі для приєднання.',
		},
		orderNotification: {
			title: '🔒 Програма недоступна',
			message: 'Ця програма заблокована, оскільки її не придбано.',
		},
	},
	gradeBook: {
		lesson: 'Урок',
		present: 'Присутній',
		absent: 'Відсутній',
		late: 'Спізнився {{time}} хв',
		online: 'Онлайн',
		join: 'Приєднатися',
		classWork: 'Класна робота',
		homeWork: 'Домашня робота',
		homeTask: 'Домашнє завдання',
		ht: 'Д/З',
		assesmentType: 'тип оцінки',
		grades: 'Оцінки',
		tisChange: 'Ви маєте доступ до уроку Toronto Imperial School. Бажаєте переключитися?',
		tisChangeButton: 'Поооїхали',
		comment: 'Коментар',
		emptyTitle: 'У вас немає уроків, запланованих на цей період',
		emptyDescription: 'Подумайте про те, щоб попрактикувати свої навички',
		thematicGrade: 'Тематична оцінка{{label}}',
		selectProgramTitle: 'Оберіть програму',
		selectProgramDescription: 'Оберіть програму, щоб побачити оцінки',
		noGradesTitle: 'Оцінок немає',
		noGradesDescription: 'За обраний період не має оцінок',
		calendarView: 'Календарний перегляд',
		teacherLeftComment: 'Учитель залишив коментар',
		emptyDay: 'Сьогодні немає занять. Насолоджуйся заслуженим відпочинком!',
		today: 'Сьогодні',
	},
	gradeBreakDown: {
		showWeekend: 'Показувати вихідні',
	},
	home: {
		main: 'Головна',
		greeting: 'Привіт, {{name}}!',
		greetingFallback: 'Привіт!',
	},
	routes: {
		access: 'Доступ',
		auth: 'Авторизація',
		home: 'Головна',
		news: 'Новини',
		resources: 'Ресурси',
		programs: 'Програми',
		lessons: 'Уроки',
		report: 'Звіти',
		certificates: 'Сертифікати',
		achievements: 'Досягнення',
		about: 'Про мене',
		strengths: 'Сильні сторони',
		goals: 'Цілі',
		steps: 'Кроки',
		create: 'Створити',
		portfolio: 'Портфоліо',
		individuality: 'Індивідуальність',
		interests: 'Інтереси',
		qualities: 'Особисті якості',
		appointments: 'Відпрацювання',
		profile: 'Профіль',
		gradebook: 'Щоденник',
		month: 'Місяць',
		chat: 'Чат',
		homework: 'Домашнє завдання',
		policies: 'Політики',
		market: 'Маркет',
		payment: 'Оплата',
		onboarding: 'Онбординг',
		tests: 'Тести',
		dashboard: 'Дашборд',
		education: 'Навчання',
		financial: 'Фінанси',
		students: 'Студенти',
		b2b: 'B2B',
		results: 'Результати',
		resetPassword: 'Скидання пароля',
	},
	profile: {
		main: 'Профіль',
		parents: 'Батьки',
		location: 'Локація',
		class: 'Клас',
		language: 'Мова',
		changePassword: 'Зміна пароля',
		resetPassword: 'Скинути пароль',
		changePasswordNotification: 'Новий пароль збережено',
		currentPasswordPlaceholder: 'Введіть поточний пароль',
		newPasswordPlaceholder: 'Введіть новий пароль',
		repeatNewPasswordPlaceholder: 'Повторіть новий пароль',
		emailPlaceholder: 'E-mail*',
		maxSizeAvatarError: 'Розмір файлу перевищує {{size}}MB ліміт',
		typeAvatarError: 'Дозволено лише файли зображень',
		clickOrDrop: 'Натисність щоб завантажити файл або перенесіть і відпустіть файл сюди',
		dropFile: 'Відпустіть файл для завантаження',
		english: 'Англійська',
		ukrainian: 'Українська',
		information: 'Інформація',
		myParents: 'Мої батьки',
	},
	themeModal: {
		title: 'Налаштування теми',
		youAreResponsible:
			'Ви відповідальні за зміну теми; якщо це ускладнює навчання, використовуйте тему за замовчуванням.',
		concentration: 'Концентрація',
		space: 'Простір',
		image: 'Завантаження зображення',
		changeBanner: 'Зміна банера',
		gradient: 'Градієнт',
		main: 'Основний',
		text: 'Текст',
		reset: 'Скинути до значень за замовчуванням',
	},
	notifications: {
		main: 'Сповіщення',
		important: 'Важливо',
		empty: 'Сповіщень немає',
		individual: 'Індивідуальні',
		general: 'Загальні',
		markAllAsRead: 'Позначити всі як прочитані',
	},
	chat: {
		main: 'Чат',
	},
	homeWork: {
		main: 'Домашня робота',
		emptyDataTitle: 'Домашнє завдання не задано',
		emptyDataSubTitle: 'Схоже що домашніх завдань на обраний період немає',
		emptyDataSubTitleForWeek: 'Схоже що домашніх завдань на наступних 7 днів немає',
		lessonTopic: 'Тема уроку',
		nextLesson: 'Наступний урок {{date}}',
		homeworkStatus: 'Статус ДЗ',
		new: 'Нове',
		inProgress: 'В роботі',
		checking: 'На перевірці',
		done: 'Виконано',
		seeAll: 'Переглянути усі',
		overdue: 'Прострочено',
	},
	policies: {
		main: 'Політики',
		emptyDataTitle: 'Наразі політики відсутні',
	},
	errorPage: {
		subTitle: '',
		goToPrograms: 'Перейти до розділу Програми',
		goToNews: 'Перейти до розділу Новин',

		newVersionAvailable: 'Доступна нова версія. Перезавантаження сторінки...',
	},
	shared: {
		viewResult: 'Переглянути результат',
		copyLink: 'Копіювати посилання',
		moreOption: 'Додаткові опції',
		shareViaEmail: 'Поділитися за допомогою електронної пошти',
		rememberMe: "Пам'ятати мене",
		childAccount: 'Обліковий запис дитини',
		schoolAdministration: 'Адміністрація школи',
		back: 'Назад',
		todo: 'Зробити',
		complete: 'Закінчити урок',
		sortBy: 'Сортувати за',
		comingSoon: 'Незабаром...',
		latest: 'Останні',
		addFile: 'Додати файл',
		save: 'Зберегти',
		submit: 'Надіслати урок',
		submitTest: 'Завершити',
		logout: 'Вихід',
		success: 'Успішно!',
		day: 'День',
		week: 'Тиждень',
		emptyDataTitle: 'Ми працюємо над додаванням контенту.',
		emptyDataSubTitle: 'Скоро все буде доступно!',
		cancel: 'Скасувати',
		cancelCaps: 'СКАСУВАТИ',
		delete: 'Видалити',
		areYouSure: 'Ви впевнені?',
		youWantToDelete: 'Ви хочете видалити цей файл',
		somethingWentWrong: 'Щось пішло не так',
		tutorial: 'Туторіал',
		loading: 'Завантаження...',
		notifications: {
			default: 'Сповіщення',
			success: 'Успішно!',
			error: 'Помилка!',
			warning: 'Увага!',
			info: 'Інформація',
		},
		days: {
			one: 'День',
			few: 'Дні',
			many: 'Днів',
		},
		hours: {
			one: 'Година',
			few: 'Години',
			many: 'Годин',
		},
		minutes: {
			one: 'Хвилина',
			few: 'Хвилини',
			many: 'Хвилин',
		},
		seconds: {
			one: 'Секунда',
			few: 'Секунди',
			many: 'Секунд',
		},
		date: 'Дата',
		theme: 'Тема',
		subject: 'Предмет',
		deadlineUntil: 'Дедлайн {{date}}',
		deadlineWas: 'Дедлайн {{date}}',
		confirm: 'Підтвердити',
		confirmCaps: 'ПІДТВЕРДИТИ',
		verifyYourself: 'Верифікуй себе',
		refresh: {
			button: 'Оновити',
			message: 'Доступна нова версія',
		},
		send: 'Відправити',
		phone: 'Номер Телефону',
		email: 'Email адреса',
		fullName: 'Повне імʼя',
		start: 'Розпочати',
		dashboard: 'Дашборд',
		review: 'Огляд',

		action: 'Дія',
		noData: 'НЕМАЄ ДАНИХ',
		search: {
			placeholder: "Ім'я, ID, тощо...",
			label: 'Пошук',
		},
		pagination: {
			rowsPerPage: 'Рядків на сторінку:',
		},
		columns: {
			studentName: 'Ім’я учня',
			emailAddress: 'Електронна адреса',
			grade: 'Клас',
			englishTest: 'Тест з англійської',
			talanted: 'Обдарований',
			action: 'Дія',
			status: 'Статус',
			group: 'Група',
			program: 'Програма',
			loa: 'LOA',
		},
		filters: {
			default: 'ФІЛЬТРИ',
		},
		applyCaps: 'ЗАСТОСУВАТИ',
		resetCaps: 'СКИНУТИ',
		seeMore: 'Побачити більше',
		sendTestPush: 'Надіслати тестовий push',
		testPushSent: 'Тестовий push надіслано',
		pushTokenUpdated: 'Push токен оновлено',
	},
	auth: {
		selectChildAccount: 'Оберіть обліковий запис дитини',
	},
	tabs: {
		aboutMe: 'ПРО МЕНЕ',
		achievement: 'ДОСЯГНЕННЯ',
		allLessons: 'ВСІ УРОКИ',
		todo: 'ЗАДАНІ',
		active: 'АКТИВНІ',
		renew: 'АНУЛЬОВАНІ',
		onChecking: 'НА ПЕРЕВІРЦІ',
		completed: 'ОЦІНЕНІ',
		books: 'КНИГИ',
		materials: 'МАТЕРІАЛИ',
		gradebook: 'ЩОДЕННИК',
		gradeBreakdown: 'ВИБІРКА ОЦІНОК',
		classWork: 'КЛАСНА РОБОТА',
		homeWork: 'ДОМАШНЯ РОБОТА',
		details: 'ДЕТАЛІ',
		teacherComment: 'КОМЕНТАР ВЧИТЕЛЯ',
		pdfReport: 'PDF ЗВІТ',
	},
	validationMessages: {
		selectOneOption: 'Виберіть один варіант',
		onlyOneOption: 'Можна вибрати лише один варіант',
		selectAtLeastOne: 'Виберіть хоча б один варіант',
		passwordsNotMatch: 'Паролі не збігаються',
		mandatory: "Обов'язкове поле",
		fileRequired: 'Потрібно додати файл',
		passwordMatch: 'Паролі повинні збігатися',
		minCharacters: {
			one: 'Пароль повинен містити щонайменше {{min}} символ',
			few: 'Пароль повинен містити щонайменше {{min}} символи',
			many: 'Пароль повинен містити щонайменше {{min}} символів',
		},
		lowercaseLetter: 'Пароль повинен містити хоча б одну маленьку літеру',
		uppercaseLetter: 'Пароль повинен містити хоча б одну велику літеру',
		invalidEmail: 'Будь ласка, введіть дійсну електронну адресу',
		passwordMin: 'Пароль має містити щонайменше 4 символи',
		login: {
			invalidEmail: 'Некоректна електронна адреса',
			passwordMin: 'Пароль має містити щонайменше 8 символів',
		},
		confirmPassword: {
			passwordMin: 'Пароль має містити щонайменше 4 символів',
			passwordsMustMatch: 'Паролі повинні збігатися',
		},
	},
	b2b: {
		studyPrograms: 'Навчальні програми',
		tuitionFees: 'Вартість навчання та збори',
		freePrograms: 'Безкоштовні програми',
		dashboard: 'Інформаційна панель',
		education: 'Освіта',
		financial: 'Фінанси',
		students: 'Учні',
		commissionStructure: 'Структура Комісії',
		contactUs: "Зв'яжіться з нами",
		contactWithUs: "Зв'яжіться з нами",
		writeToUs: 'Напишіть нам у чаті',
		free: 'Безкоштовно',
		payment: 'Вартість навчання',
		all: 'Усі',
		constUsModalDescription:
			'Залиште свій номер телефону, і наш спеціаліст надасть вам <highlight>безкоштовну консультацію</highlight>, щоб допомогти підібрати ідеальний варіант саме для вас.',
		partnersPathway: {
			title: 'Партнерський шлях до успіху',
			step: 'Крок',
		},
		profile: {
			aboutMe: 'Про мене',
			firstName: "Ім'я",
			lastName: 'Прізвище',
			emailAddress: 'Електронна пошта',
			phoneNumber: 'Номер телефону',
			country: 'Країна',
			city: 'Місто',
			institutionName: 'Назва закладу',
			institutionType: 'Тип закладу',
			memorandum: 'Меморандум про надання послуг',
			officialPartnershipCertificate: 'Офіційний сертифікат партнерства',
			teacherCertificate: 'Сертифікат вчителя',
			certificate: 'Cертифікат',
			b2bTestCompletionCertificate: 'Сертифікат проходження тесту з англійської мови',
		},
		onboardingHub: {
			title: 'Центр адаптації',
			step1Title: 'Сертифікат та меморандум',
			step1Description: 'Отримайте сертифікат і пропонуйте ексклюзивні переваги для студентів',

			step2Title: 'Освітня програма',
			step2Description: 'Покроковий план з інструментами та прикладами для легкого навчання',

			step3Title: 'Фінансова мотивація',
			step3Description: 'Отримуйте комісію за кожного залученого студента',

			step4Title: 'Почніть із запрошення студентів',
			step4Description: 'Запрошуйте студентів приєднуватися до курсів і починати навчання',

			step5Title: 'Запустіть свою першу групу',
			step5Description: 'Покроковий план з інструментами та прикладами для легкого навчання',

			getIt: 'Отримати',
			detail: 'Деталі',
			step: 'Крок',
		},
		video: {
			title: 'Відео',
		},
		documents: { default: 'Документи' },
		welcomeModal: {
			title: 'Ласкаво просимо на платформу партнерів Toronto Imperial School!',
			description:
				'Ми раді вітати вас у нашій команді.<br /><br />Ця платформа створена для того, щоб допомогти вам пройти ключові етапи, які має завершити кожен партнер. Ви знайдете всю необхідну інформацію про наші програми, отримаєте доступ до важливих ресурсів та підготуєтеся до роботи з родинами та учнями.<br /><br />Почнемо!',
			button: 'Почнемо.',
		},
		launchModal: {
			title: '🎓 Запуск вашої першої навчальної групи',
			description:
				'Вітаємо — ви вже майже на фінішній прямій!<br />Ваша перша група студентів ось-ось розпочне навчання.<br /><br />На цій сторінці ви знайдете все необхідне:<br />✔️ Стартові матеріали<br />✔️ Підтримку від команди TIS<br />✔️ Кроки для супроводу студентів<br /><br />Готові надихати та заробляти?<br />Натискайте "Розпочати" нижче — і вперед у нову подорож!<br />',
			button: 'Розпочати',
		},
		memorandum: {
			title: 'Меморандум про партнерство',
			whatIsTitle: 'Що таке Меморандум про партнерство?',
			whatIsDescription:
				'Меморандум про партнерство — це простий, необов’язковий документ, який підтверджує ваш інтерес до академічної співпраці з Toronto Imperial School через платформу TIS.<br /> Він <b>не</b> створює жодних юридичних, фінансових чи адміністративних зобов’язань.',

			whyImportantTitle: 'Чому це важливо',
			whyImportantDescription: 'Приймаючи принципи цього меморандуму, ваша установа:',
			whyImportantList: {
				item1: 'Можливість проводити тести та діагностику для ваших студентів',
				item2: 'Доступ до консультацій, воркшопів і вебінарів з сертифікованими фахівцями TIS',
				item3: 'Отримання ексклюзивних навчальних інструментів, акцій і пропозицій для партнерів',
				item4: 'Пріоритетна підтримка та онбординг від команди TIS',
			},

			footer: 'Жодних оплат. Жодної бюрократії. Лише можливості для зростання разом.',
		},
		partnerAcknowledgementCertificate: {
			title: 'Вітаємо!',
			line1: 'Ви отримали офіційний сертифікат партнера від Toronto Imperial School',
			line2:
				'Тепер ви офіційно уповноважені представляти школу та найкращі пропозиції для своїх студентів як сертифікований партнер.',
			line3: 'Ваш сертифікат зберігається у вашому особистому кабінеті.',
			line4:
				'Ви можете завантажити або показати його будь-коли на запит. Цей сертифікат підтверджує ваш надійний статус і професійне визнання.',
		},
		teacherCertificate: {
			title: 'Це ваш сертифікат про завершення програми.',
			line1: 'Його видано на ваше ім’я та він підтверджує вашу успішну участь.',
			line2: 'Ви можете переглянути його онлайн або завантажити у форматі PDF.',
		},
		financialPage: {
			title: 'Фінансова модель: комісія на основі обсягу',
			intro:
				'У Toronto Imperial School ми співпрацюємо з партнерами за моделлю комісії на основі обсягу. Такий підхід прозорий, гнучкий і сприяє довготривалій співпраці.',
			b2cTitle:
				'<t>B2C ціна</t> - Повна вартість програми, яку сплачує студент. Це ціна, яку ви вказуєте своїм клієнтам.',
			b2bTitle:
				'<t>B2B ціна</t> - Сума, яку ваша організація сплачує Toronto Imperial School після вирахування комісії.',
			howItWorksTitle: 'Як це працює',
			howItWorksDescription:
				'Чим більше студентів ви залучаєте, тим вища ваша комісія. Кількість студентів та партнерська комісія (від B2C ціни)',
			row0: '1–4 студентів',
			row1: '5–10 студентів',

			row2: '11–30 студентів',
			row3: '30+ студентів',
			commissionNote: 'Комісія розраховується з B2C ціни.',
			commissionNoteSecond: 'Ви залишаєте комісію собі та сплачуєте нам B2B ціну.',
			exampleTitle: 'Приклад: Програма OSSD з самостійним навчанням',
			exampleText1: 'Якщо B2C ціна становить 970 CAD на студента, ви заробляєте:',
			exampleText0: '145 CAD за студента при комісії 15%',
			exampleText2: '290 CAD за студента при комісії 30%',
			exampleText3: '340 CAD за студента при комісії 35%',
			exampleText4: '440 CAD за студента при комісії 40%',
			whyItWorksTitle: 'Чому ця модель працює',
			why1: 'Проста і зрозуміла структура — жодних прихованих платежів або плутанини',
			why2: 'Винагорода за результат — чим більше зростаєте, тим більше заробляєте',
			why3: 'Гнучкість для будь-якого партнера — підходить для шкіл, агентств, репетиторів або індивідуальних викладачів',
			why4: 'Масштабованість — доступно для OSSD, Pre-OSSD, UFT і Talented',
			contactNote:
				'Якщо у вас виникли запитання — зверніться до вашого менеджера підтримки партнерів.',
			table: {
				program: 'Програма',
				note: '*Зверніть увагу, що кожен учасник програми сплачує реєстраційний внесок у розмірі 140 канадських доларів.',
				volume: 'Обсяг',
				duration: 'Тривалість курсу',
				b2cPrice: 'Ціна B2C',
				commission: 'Комісія',
				b2bPrice: 'Ціна B2B',
				ossdTeacher: 'OSSD з викладачем',
				ossdSelf: 'OSSD самостійно',
				preOssd: 'Pre-OSSD з викладачем',
				career: 'Карʼєрний дизайн',
				group: 'група',
				individual: 'індивідуально',
				title: 'Зростаймо разом: плани та комісії',
				gotQuestion: 'Є запитання?',
				answer: 'Натисни кнопку нижче та залиш запит — ми допоможемо!',
				button: 'Залишити запит',
			},
		},
		studentsPage: {
			addStudent: 'Додати студентів',
			modalMessage: 'Або поділіться посиланням для швидкої реєстрації:',
			uniqueLink: 'Створіть унікальне посилання для спільного доступу.',
			copiedAndSent: 'Його можна скопіювати та надіслати будь-яким зручним способом.',
			generateLinks: 'Згенерувати посилання',
		},
		talented: {
			notification: {
				title: 'Повідомлення:',
				welcome: 'Вітаємо на платформі Talented!',
				message:
					'Тут ви знайдете основну інформацію по співпраці з Talented. А також, тут ви можете створювати учнівські запрошення, трекати прогрес учнів та переглядати учнівські профілі.',
			},
			onboardingHub: {
				step1Title: 'Сертифікат та меморандум',
				step1Description: 'Отримайте партнерські сертифікати',

				step2Title: 'Навчальні програми',
				step2Description: 'Ознайомтесь із безкоштовними та платними продуктами',

				step3Title: 'Фінансова мотивація',
				step3Description: 'Дізнайтесь про бонуси та комісії',

				step4Title: 'Запрошення учнів',
				step4Description: 'Створюйте індивідуальні посилання для тестів',

				step5Title: 'Запуск першої групи',
				step5Description: 'Почніть навчання разом із Talented',

				getIt: 'Отримати',
				detail: 'Деталініше',
			},
			documents: {
				memorandum: 'Меморандум про намір',
				partnerCertificate: 'Сертифікат партнера',
				teacherCertificate: 'Сертифікат фасилітатора / ментора / викладача',
				b2bPresentation: 'B2B презентація',
			},
		},
		events: {
			default: 'Події',
		},
	},
	media: {
		preview: 'Огляд',
		play: 'Відтворити',
		dropToUpload: '<FileUploadTextPrimary>Відпустіть файл</FileUploadTextPrimary> для завантаження',
		clickToUpload:
			'<FileUploadTextPrimary>Натисніть щоб завантажити</FileUploadTextPrimary> або перенесіть та відпустіть',
		formatPdf500: 'PDF (макс. 500MB)',
		formatImageDefault: 'SVG, PNG, JPG або GIF (макс. 3MB)',
		formatChunkFile: 'Фото, PDF, Office пакет (макс. 100MB)',
		formatChunkScorm: 'Файл типу скорм (макс. 762.94MB)',
		formatVideo500: 'Відео файл (макс. 500MB)',
	},
	common: {
		chat: {
			rules: 'Правила',
			continue: 'Продовжити',
		},
	},
	tests: {
		default: 'Тести',
		signup: {
			welcome: 'Ласкаво просимо!',
			message: 'Перш ніж розпочати тренувальний тест, будь ласка, пройдіть коротку реєстрацію.',
			startTest: 'Почати тест',
		},
		cta: {
			submit: 'Завершити {{slideName}}',
			submitting: 'Відправка...',
			startTest: 'Розпочати тест',
		},
		time: 'Час',
		test: 'Тест',
		modal: {
			title: '📝 Для вас доступний тест {{testName}}',
			message: 'Новий тест вже доступний. Зосередьтесь і підготуйтеся — це займе небагато часу',
			cta: 'Розпочати тест',
		},
		modalIELS: {
			title: '{{testName}} активовано! 🎉',
			p1: 'Тест розпочнеться <bold>одразу</bold> після натискання на кнопку <bold>«Розпочати»</bold>.',
			p2: 'На першій сторінці уважно ознайомтесь з деталями проходження, там всі важливі правила роботи з тестом ✅',
			p3: 'Якщо ви плануєте пройти тест пізніше, натисність на <bold>хрестик</bold> у верхньому правому кутку. Ви зможете повернутись до тесту в будь-який день у межах дедлайну, натиснувши на <bold>синій прапорець</bold> праворуч на екрані.',
			p4: 'Тримаємо кулачки ✊🏻✨',
			cta: 'Розпочати тест',
		},
		thankYouPage: {
			title: 'Дякуємо за проходження тесту!',
			message1: 'Ваші відповіді успішно надіслані.',
			message2: 'Незабаром ви отримаєте результати.',
			pro: {
				welcome: 'Вітаємо, <strong>{{userName}}</strong> 👋',
				yourRIASECResluts: 'Ваші результати RIASEC',
				note: '<strong>Примітка:</strong> Результати тесту відображають ваш поточний стан, реакції та настрій на момент проходження тесту. Вони є показниками ваших схильностей і зацікавлень, але не визначають конкретну професію чи спеціальність. <br /><br /> Пам’ятайте, що ці результати можна застосовувати в різних сферах діяльності. Вони слугують орієнтиром для розуміння ваших сильних сторін і потенціалу, який можна реалізувати в багатьох професійних галузях.',
				takeReport: 'Заберіть свій звіт із собою — один клік, і PDF готовий.',
				downloadThePdf: 'Завантажити PDF',
			},
		},
		results: 'Результати тестів',
		resultsReview: {
			yourLevel: 'Ваш рівень',
			studentCurrentLevel: 'Поточний рівень студента',
			recommendedLevel: 'Рекомендований рівень',
			yourCertificate: 'Ваш сертифікат',
			greatJob:
				'Чудова робота — ви досягли рівня {{levelShortName}}, що відповідає {{levelLongName}} рівню англійської мови.',
			nextStep: 'Ви готові до наступного етапу — рівня {{levelShortName}}!',
			nextLearningPath: 'Ми вже підготували для вас новий шлях навчання.',
			nextLearningPathDescription:
				'Нові уроки, практичні завдання та виклики вже чекають на вас. Давайте разом покращимо вашу лексику, граматику та вільне мовлення.',
			cta: 'Розпочати шлях до рівня {{levelShortName}}',
			certificate: 'Сертифікат',
			congratulations: '🎉 Вітаємо!',
			certificateSectionText:
				'Ви успішно пройшли тест на рівень англійської мови. Хочете підтвердити свій результат? Отримайте персоналізований сертифікат і впевнено демонструйте свої навички!',
			completionOfAssessment: 'Завершення оцінювання – Рівень {{level}}',
			completionOfAssessmentTest:
				'Чудові новини! Цей студент виконав необхідні кроки та відкрив нові програми.',
			seeCertificate: 'Переглянути сертифікат',
			getCertificateCta: 'Отримати Мій Сертифікат',
			personalizeModal: {
				title: 'Персоналізація',
				text: 'Щоб персоналізувати ваш сертифікат, введіть повне ім’я так, як ви хочете, щоб воно відображалося в сертифікаті.',
			},
			programProposition: {
				title: 'Пропозиція програм',
				name: 'Імʼя',
				cost: 'Вартість',
				yourCommission: 'Ваша комісія',
			},
			resultsAnalysis: 'Аналіз результатів',
			certificateModal: {
				title: 'Вітаємо!',
				text: 'Ви успішно пройшли <strong>Placement Test</strong> у <strong>Toronto Imperial School</strong> — чудова робота!</br></br> Це ваш <strong>перший крок до міжнародного академічного успіху</strong>, і ми раді бути частиною вашої подорожі. Ваш сертифікат вже доступний у розділі <strong>«Документи»</strong> вашого особистого кабінету.</br></br> Ми готові супроводжувати та підтримувати вас на кожному етапі.</br></br> Рухаймося вперед разом!',
			},
		},
		alreadyRegisteredEmailModal: {
			title: '🔔 Цей email уже зареєстрований',
			text1:
				'Схоже, що цей email уже пов’язаний з обліковим записом. Ми надіслали повідомлення з посиланням на тест на вашу поштову скриньку.',
			text2:
				'Якщо ви хочете створити новий обліковий запис, будь ласка, використайте іншу адресу email.',
		},
	},
};

export default LANGUAGE_FILE_UK;
